import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { MainTabs } from "../../components/tab";
import { selectCurrentUser } from "../../features/authentication/services";
import { useSalesModeContext } from "../../features/sales/contexts";
import { useAppSelector } from "../../hooks";
import { ILinkTabProps } from "../../types/interfaces";
import { isProduction } from "../../utils";

const ItemTabs = () => {
    const navigate = useNavigate();
    const { isOrderingMode } = useSalesModeContext();

    const { pathname } = useLocation();
    const currentUser = useAppSelector(selectCurrentUser);
    const orgId = currentUser?.org_id;
    const pathnameSplit = pathname?.split("/");
    const currentRoute = pathnameSplit[pathnameSplit?.length - 1] || "";

    const [currentTab, setCurrentTab] = useState(0);

    // Build tab routes based on sales mode
    const baseTabs = [{ labelKey: "SALES.Category", href: "category" }];

    // 原先的i18n字詞： SALES.Extra_Info, SALES.Shared_Spec
    const modeSpecificTab = isOrderingMode
        ? { labelKey: "加購項目", href: "shared-spec" }
        : { labelKey: "額外資訊", href: "extra-info" };

    const manageTabs = [{ labelKey: "SALES.ItemManage", href: "item", initHref: "" }];

    const prodRoute = [...baseTabs, modeSpecificTab, ...manageTabs];

    const tabRoutes: ILinkTabProps[] = isProduction ? prodRoute : [...prodRoute];

    const findIdx = tabRoutes.findIndex((r) => r.href === currentRoute);

    const handleChange = (newValue: number) => {
        setCurrentTab(newValue);
    };

    useEffect(() => {
        // if findIdx is not -1, means it's project dashboard index page, show current tab === Dashboard
        if (findIdx !== -1) {
            setCurrentTab(findIdx);
            return;
        }
        setCurrentTab(0);
    }, [findIdx, currentRoute]);
    return (
        <>
            <MainTabs
                currentTab={currentTab}
                handleChange={handleChange}
                tabsOnClick={(tabRoute) => {
                    if (tabRoute.initHref) {
                        navigate(`/sale/org/${orgId}/item/${tabRoute.initHref}`);
                    } else if (tabRoute.initHref === "") {
                        navigate(`/sale/org/${orgId}/item`);
                    } else {
                        navigate(`/sale/org/${orgId}/item/${tabRoute.href}`);
                    }
                }}
                tabRoutes={tabRoutes}
                isPill={true}
            />
        </>
    );
};

export default ItemTabs;
